<template>
  <el-popover
    v-bind="$attrs"
    v-on="$listeners"
    :ref="`${_uid}-popover`"
    v-on:show="popoverShow(`${_uid}-popover`)"
    v-on:hide="popoverHide(`${_uid}-popover`)"
  >
    <h3 class="popover-title">{{this.title}}</h3>

    <div class="actions-list">
      <div class="elsa-input">
        <el-input
          class="search-users"
          prefix-icon="el-icon-search"
          :placeholder="$t('common.search')"
          v-model.lazy="queryString"
        />
      </div>

      <div class="item-list">
        <span
          v-for="({name, id}, idx) in parsedData"
          :key="`${_uid}-${idx}`"
          @click="actionFunction(id, user)"
        >
          {{ name }}
        </span>
      </div>

    <div class="more-options">
      <slot name="moreOption">
      </slot>
    </div>
  </div>

  <slot slot="reference"></slot>
  </el-popover>
</template>

<script>
  import { either, isEmpty, isNil, filter, compose, prop, startsWith, toLower } from 'ramda'

  export default {
    data() {
      return {
        queryString: "",
      }
    },
    props: {
      displayData: {
        type: Array,
        default: () => []
      },
      actionFunction: {
          type: Function,
          default: () => {}
      },
      title: {
        type: String,
      },
      user: {},
      parentRow: {},
      isRowElement: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      popoverHide(ref){
        if(this.isRowElement) {
          this.$refs[ref].$el.classList.remove('active-svg')
          this.$el.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove('active')
        }
      },
      popoverShow(ref){
        if(this.isRowElement) {
          this.$refs[ref].$el.classList.add('active-svg')
          this.$el.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add('active')
        }
      }
    },
    computed: {
      parsedData() {
        if(either(isEmpty, isNil)(this.queryString)) {
          return this.displayData;
        }
        const lowerQueryString = toLower(this.queryString)

        return filter(
          compose(
            startsWith(lowerQueryString),
            toLower,
            prop("name")
          ),
        )(this.displayData)
      }
    },
  }
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";

.item .el-popover__reference span {
  margin: 0;
}

.el-popover.el-popper {
    .popover-title {
      font-weight: 500;
      font-size: 14px;
      color: $darker-blue;
    }

    .actions-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .item-list, .more-options {
      display: flex;
      flex-direction: column;
    }

    .elsa-input::v-deep {
      width: 100%;

      div.search-users .el-input__inner {
        padding-left: 16px;
      }
    }

    .item-list {
      margin-top: 12px;
      padding-bottom: 16px;
      border-bottom: 1px solid $purple;
      max-height: 200px;
      overflow: scroll;
      width: 100%;
      span {
        font-weight: 300;
        color: #6D7A8C;
      }
    }

    ::v-deep .more-options {
      margin-top: 16px;
      span {
        font-weight: 600;
        color: $purple;

        i {
          padding-right: 8px;
        }
      }


    }
  }
}
</style>
